import _ from 'lodash';
import React, { useMemo, useContext } from 'react';

import { TableCell as MuiTableCell } from '@mui/material';

import { TableContext } from './context.table';

export const TableCell = ({ key, ...props }: any) => {
  // @ts-expect-error TS(2339): Property 'styles' does not exist on type '{ onSort... Remove this comment to see the full error message
  const { styles, ...ctx } = useContext(TableContext);
  const { column, row, ctx: context, ...htmlAttributes } = props;

  const data = _.get(row, column.name);
  let cellContent = data;
  let cellProps = {};

  if (_.isFunction(column.Cell)) {
    cellContent = column.Cell(props);
  }

  if (_.isObject(column.Cell)) {
    cellProps = _.omit(column.Cell, 'C');

    if (_.has(column.Cell, 'C')) {
      cellContent = column.Cell.C(props);
    }
  }

  const classes = useMemo(() => {
    if (styles) {
      return typeof styles.cell === 'function'
        ? styles.cell(data)
        : styles.cell || {};
    }

    return {};
  }, [styles, data]);

  const inlineStyle = useMemo(() => {
    // @ts-expect-error TS(2339): Property 'fixed' does not exist on type '{ onSort:... Remove this comment to see the full error message
    return ctx.fixed
      ? {
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          // @ts-expect-error TS(2339): Property 'style' does not exist on type '{}'.
          ...cellProps.style,
        }
      : props.style;
    // @ts-expect-error TS(2339): Property 'fixed' does not exist on type '{ onSort:... Remove this comment to see the full error message
  }, [ctx.fixed, cellProps.style, props.style]);

  if (column.show === false) {
    return null;
  }

  return (
    <MuiTableCell
      key={key}
      {...htmlAttributes}
      align="left"
      classes={classes}
      {...cellProps}
      style={inlineStyle}
    >
      {cellContent}
    </MuiTableCell>
  );
};

TableCell.displayName = 'TableCell';
